"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagneticFieldDome = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MagneticFieldDome = (function (_super) {
    __extends(MagneticFieldDome, _super);
    function MagneticFieldDome() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MAGNETIC_FIELD_DOME,
            tags: [Tags_1.Tags.BUILDING],
            cost: 5,
            productionBox: Units_1.Units.of({ energy: -2, plants: 1 }),
            metadata: {
                cardNumber: '171',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(2).br;
                        pb.plus().plants(1);
                    });
                    b.tr(1);
                }),
                description: 'Decrease your Energy production 2 steps and increase your Plant production 1 step. Raise your TR 1 step.',
            },
        }) || this;
    }
    MagneticFieldDome.prototype.canPlay = function (player) {
        var hasEnergyProduction = player.getProduction(Resources_1.Resources.ENERGY) >= 2;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST, { steel: true }) && hasEnergyProduction;
        }
        return hasEnergyProduction;
    };
    MagneticFieldDome.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -2);
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.increaseTerraformRating();
        return undefined;
    };
    return MagneticFieldDome;
}(Card_1.Card));
exports.MagneticFieldDome = MagneticFieldDome;
//# sourceMappingURL=MagneticFieldDome.js.map